import React from "react";
import { Link } from "react-router-dom";
import { IMG } from "../data/mock";

// Exact "Life With Abba" logo from the original site.
export default function Logo({ className = "" }) {
  return (
    <Link to="/" className={`inline-flex items-center select-none ${className}`}>
      <img
        src={IMG.logo}
        alt="Life With Abba"
        className="w-[176px] h-auto"
        width={320}
        height={186}
      />
    </Link>
  );
}
